export const colorFileExtension = {
    rvt: '#0070C0',
    nwc: '#00B050',
    nwd: '#00B050',
    ifc: '#FFCC32',
    default: '#278e2d'
}